import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/layout";
import { BASE_SITE_URL } from "../../shared/constants";
import BannerBgImage from "../../assets/Images/podcast/pod-banner.png";
import Image1 from "../../assets/Images/podcast/image2.png";
import PodPodCastItem from "../../components/hostLib/podPodCastItem";
import { graphql } from "gatsby";
import PodCastBanner from "../../components/hostLib/banner";
import PodCastHeroBanner from "../../components/hostLib/heroBanner";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import Clm1Img from "../../assets/Icons/phone.svg";
import Clm2Img from "../../assets/Icons/mail.svg";
const TwoColumnContactInfoData = {
  Clm1Img: Clm1Img,
  Clm1Title: "Phone:",
  Clm1SubTitle: "+44 (0) 161 706 7983",
  Clm2Img: Clm2Img,
  Clm2Title: "Email:",
  Clm2SubTitle: "hello@digiryte.com",
};

export const podCastQuery = graphql`
  query {
    allSanityPodcast {
      nodes {
        title
        provider {
          name
          link
        }
        content {
          children {
            text
          }
        }
        publishedAt
        podcastDuration
        episode
        authors
        shortDescription
        _id
        socialMedia {
          link
          name
        }
        slug {
          current
        }
        titleImage {
          asset {
            url
          }
        }
      }
    }
  }
`;

const Podcast = ({ data }) => {
  const [podcastData, setPodCastData] = useState([]);

  useEffect(() => {
    if (data?.allSanityPodcast?.nodes) {
      setPodCastData(data?.allSanityPodcast?.nodes);
    }
  }, [data]);

  const ImageBannerData = {
    ImgUrl: BannerBgImage,
    title: "DIGITECH",
    subtitle: (
      <>
        Exploring Tomorrow’s Technology – <br />
        AI, Cloud, and Beyond
      </>
    ),
  };

  return (
    <React.Fragment>
      <Layout
        seo={{
          title: `Podcast | DigiRyte`,
          ogtitle: "Podcast | DigiRyte",
          description:
            "Boost your engineering capacity and achieve rapid scalability by establishing an in-house tech team in India with DigiRyte. We onboard the top 3% of industry-specific talent from the UK.",
          ogimage: "",
          ogurl: `${BASE_SITE_URL}`,
          keywords:
            "offshore software development, in-house tech team, engineering capacity, scalability, industry-specific talent, DigiRyte",
        }}
      >
        <PodCastHeroBanner bannerData={ImageBannerData} />
        <PodCastBanner
          heading="An actual real"
          LineColor="podcast."
          title=""
          description="The goal of the DigiTech podcast is to explore the fascinating and frequently complicated nexus of life, business, and technology. the victories, challenging moments, and pivotal moments."
          description_2="Our casual conversations include the past, present, and future. We highlight the positive aspects while attempting to make sense of the challenges, from life-changing events to character-defining turning points, the technology that's made a difference, and the “one big thing” worth sharing. Get a cup of coffee and come along as we explore DigiTech."
          image={Image1}
        />

        <PodPodCastItem objectList={podcastData} />

        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </Layout>
    </React.Fragment>
  );
};

export default Podcast;
